export default (initialState = { menus: []}) => {
  // 在这里按照初始化数据定义项目中的权限，统一管理
  // 参考文档 https://umijs.org/docs/max/access
  if(!initialState){
    return {}
  }
  const { menus = [] } = initialState;
  let roulst: any = {};
  const defaultAccess = {
    ['sys:menu:assistant:create']: false,
  };
  menus.forEach((item: any) => {
    if (item.children) {
      item.children.forEach((child: any) => {
        roulst[child.path] = true;
      });
    }
    roulst[item.path] = true;
  });
  return {
    ...defaultAccess,
    ...roulst,
  };
};
